import ru from './ru.json'
import en from './en.json'

export const defaulLocale = 'ru';

export const languages = {
    en, ru
}
